import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { EXAMINATION_CENTERS_ERROR, GETTING_EXAMINATION_CENTERS, GET_EXAMINATION_CENTERS } from "../types"

export const fetchExaminationCenters = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/examination-centers`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_EXAMINATION_CENTERS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_EXAMINATION_CENTERS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: EXAMINATION_CENTERS_ERROR,
            error
        })
    }
}
